import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { StyleOne, StyleTwo } from '../components/RelatedSCard';
import Jobs from '../data/products.json';
import Not from '../components/NotFound'
import renderHTML from 'react-render-html'
import asset from '../assets/images/IMG_0436.jpg'
// import institutional from '../assets/images/IMG_0415.JPG'
// import wealth from '../assets/images/IMG_0415.JPG'
// import investment from '../assets/images/IMG_0415.JPG'
// import stockbroking from '../assets/images/IMG_0415.JPG'
// import corporate from '../assets/images/IMG_0415.JPG'
// import online from '../assets/images/IMG_0415.JPG'
// import fixed from '../assets/images/IMG_0415.JPG'
// import treasury from '../assets/images/IMG_0415.JPG'
// import foreign from '../assets/images/IMG_0415.JPG'
// import interest from '../assets/images/IMG_0415.JPG'
// import pensions from '../assets/images/IMG_0415.JPG'

class ServiceDetail extends Component {


    state = {
        // bucket: [],
        Jobs: {
            Jobs: []
        },
    }

    componentDidMount() {
        this.setState({ Jobs })
    }

    render() {
        console.log(this.props);
        const { serviceName, bodytext} = this.props; //Not in use now

        const { Jobs } = this.state

        const foundService = Jobs.Jobs.some(result => result.links === this.props.match.params.service);

        const foundObject = Jobs.Jobs.filter(result => result.links === this.props.match.params.service);

        // var job = foundObject[0];
        // console.log(foundObject);
        // console.log(job);
        
        // if (foundService === false) {
        //     /* if Jobs contains the element we're looking for */
        //     return (
        //         <Not/>
        //     )
        // }
     
        return (
            <div className={'service-full '+this.props.match.params.service}>
            {foundObject.map(job => {
                return (                    
                    <header key={job.title} className="banner" style={{backgroundImage: `url(${asset})`, }}> 
                        <div className="container-fluid">
                            <div className='paginations'>
                                <div className="gray-button-sm">
                                    <Link to='/'>Home</Link>
                                </div>
                                <div className="blue-button-sm">
                                    <Link to='/servicelist/advisory'>Services</Link>
                                </div>
                                {/* <div className="lightblue-button-sm">
                                    <Link to='/servicelist/'>{this.props.match.params.tabview}</Link>
                                </div> */}
                            </div>
                            <div className="header-text">
                                <h1 className='bold'>{job.title}</h1>
                            </div>
                        </div>
                    </header>


                )
            })}
            {foundObject.map(job => {
                    return (

                <div key={job.title} className="details">
                    <div className="container-fluid">
                        <div className="col-sm-8 col-md-7 no-gutter-left">
                            {/* <div className="">
                            {job.title}
                            </div> */}
                            <br/>
                            <p>
                            {renderHTML(job.bodyText)}
                              {bodytext}
                            </p>
                            <br/>
                            {/* {foundObject.map(job => {
                                return (
                                    <div className="tagging gray-button-sm">
                                        <Link to="/" className="gray-button-sm">{job.tags[0]}</Link>
                                    </div>
                                )})} */}
                            <div className="tagging gray-button-sm">
                            <Link to= {(() => {
                              switch (job.tags[0]) {
                                case "Advisory": return "/servicelist/advisory";
                                case "Financing": return "/servicelist/financing";
                                case "Risk Management": return "/servicelist/rManagement";
                                case "Cash Management": return "/servicelist/cManagement";
                                case "Wealth Management": return "/servicelist/wManagement";
                                case "Global Markets": return "/productlist/gMarkets";
                                case "Corporate Banking": return "/productlist/cBanking";
                                case "Investment Banking": return "/productlist/iBanking";
                                case "Prestige Banking": return "/productlist/pBanking";
                                case "Others": return "/productlist/others";
                                case "Products": return "/productlist/gMarkets";
                                case "Services": return "/servicelist/advisory";
                                default: return "/";
                              } 
                            })()} className="gray-button-sm">{job.tags[0]}</Link>
                            <Link to= {(() => {
                              switch (job.tags[1]) {
                                case "Advisory": return "/servicelist/advisory";
                                case "Financing": return "/servicelist/financing";
                                case "Risk Management": return "/servicelist/rManagement";
                                case "Cash Management": return "/servicelist/cManagement";
                                case "Wealth Management": return "/servicelist/wManagement";
                                case "Global Markets": return "/productlist/gMarkets";
                                case "Corporate Banking": return "/productlist/cBanking";
                                case "Investment Banking": return "/productlist/iBanking";
                                case "Prestige Banking": return "/productlist/pBanking";
                                case "Others": return "/productlist/others";
                                case "Products": return "/productlist/gMarkets";
                                case "Services": return "/servicelist/advisory";
                                default: return "/";
                              } 
                            })()} className="gray-button-sm">{job.tags[1]}</Link>
                            <Link to= {(() => {
                              switch (job.tags[2]) {
                                case "Advisory": return "/servicelist/advisory";
                                case "Financing": return "/servicelist/financing";
                                case "Risk Management": return "/servicelist/rManagement";
                                case "Cash Management": return "/servicelist/cManagement";
                                case "Wealth Management": return "/servicelist/wManagement";
                                case "Global Markets": return "/productlist/gMarkets";
                                case "Corporate Banking": return "/productlist/cBanking";
                                case "Investment Banking": return "/productlist/iBanking";
                                case "Prestige Banking": return "/productlist/pBanking";
                                case "Others": return "/productlist/others";
                                case "Products": return "/productlist/gMarkets";
                                case "Services": return "/servicelist/advisory";
                                default: return "/";
                              } 
                            })()} className="gray-button-sm">{job.tags[2]}</Link>
                            <Link  to= {(() => {
                              switch (job.tags[3]) {
                                case "Advisory": return "/servicelist/advisory";
                                case "Financing": return "/servicelist/financing";
                                case "Risk Management": return "/servicelist/rManagement";
                                case "Cash Management": return "/servicelist/cManagement";
                                case "Wealth Management": return "/servicelist/wManagement";
                                case "Global Markets": return "/productlist/gMarkets";
                                case "Corporate Banking": return "/productlist/cBanking";
                                case "Investment Banking": return "/productlist/iBanking";
                                case "Prestige Banking": return "/productlist/pBanking";
                                case "Others": return "/productlist/others";
                                case "Products": return "/productlist/gMarkets";
                                case "Services": return "/servicelist/advisory";
                                default: return "/";
                              } 
                            })()} className="gray-button-sm">{job.tags[3]}</Link>
                            </div>

                            {/* <p>
                                Getting started is easy!  All you need to do is contact the {serviceName} Team by email at:
                            </p>
                            <p className='mailing'>
                                {job.email}
                            </p>
                            <p className='mailing'>
                                {job.telephone}
                            </p> */}
                        </div>
                    </div>
                </div>
                
                )
            })}

                {/* <div className="section-alt">
                    <div className="container-fluid">
                        <div className="row">
                            <StyleOne tag='services' serviceDesc='Investment Banking' bgcolor='dark-blue-bg' buttonText='Learn more'/>
                            <StyleTwo tag='services' serviceDesc='Finance and grow your business' bgcolor='burgundy-bg' buttonText='Learn more'/>
                            <StyleOne tag='services' serviceDesc='Corporate Banking' bgcolor='light-blue-bg' buttonText='Learn more'/>
                            <StyleTwo tag='services' serviceDesc='Finance and grow your business' bgcolor='burgundy-bg' buttonText='Learn more'/>
                        </div>
                    </div>
                </div> */}
            </div> 
        );
    }
}

export default ServiceDetail;